exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Article-module__article___2Ofn_{max-width:100%;width:1100px;margin:auto;background-color:#cbe5f4;padding:48px 64px;border-radius:10px;display:grid;gap:32px}.Article-module__article___2Ofn_.Article-module__red___3Ll2G{background-color:#ecc0bc}.Article-module__article___2Ofn_.Article-module__blue___1pkuV{background-color:#cbe5f4}.Article-module__article___2Ofn_.Article-module__brown___1FoI1{background-color:#e8e2d7}.Article-module__article___2Ofn_.Article-module__yellow___1DSdB{background-color:#fff0b1}@media (max-width:800px){.Article-module__article___2Ofn_{padding:24px 32px}}.Article-module__article___2Ofn_ h1{padding-bottom:12px}", ""]);

// exports
exports.locals = {
	"article": "Article-module__article___2Ofn_",
	"red": "Article-module__red___3Ll2G",
	"blue": "Article-module__blue___1pkuV",
	"brown": "Article-module__brown___1FoI1",
	"yellow": "Article-module__yellow___1DSdB"
};